import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'

import {
  TextAligning,
  TextBox,
  TextBoxColors,
  TextBoxTypes,
} from 'atoms/TextBox'

export interface ITextBoxBody4SecondaryProps extends ITextBoxProps {}

export const TextBoxBody4Secondary = ({
  title,
  color = TextBoxColors.SURFACE_DARK_7,
  font = TextBoxTypes.Body4,
  alignment = TextAligning.Left,
  ...rest
}: ITextBoxBody4SecondaryProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    {...rest}
  />
)
